import { render, staticRenderFns } from "./ListaEmpresas.vue?vue&type=template&id=006755f7&scoped=true"
import script from "./ListaEmpresas.vue?vue&type=script&lang=js"
export * from "./ListaEmpresas.vue?vue&type=script&lang=js"
import style0 from "./ListaEmpresas.vue?vue&type=style&index=0&id=006755f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006755f7",
  null
  
)

export default component.exports